export default {
  GET_RESULTS: 'GET_RESULTS',
};
